import BaseModel from '../core/BaseModel'
export default class VisitOrderItemProductModel extends BaseModel {

    constructor() {
        super({
                name: "visit_order_item_product",
                tableName: 'visit_order_item_product',
                label: "Visit Order Product"
            },
            {
                stt: {
                    name: "stt",
                    label: "No.",
                    type: "Computed",
                    computed: (data, index) => {
                        data.stt = index + 1;
                    },
                },
                id: {
                    name: 'id',
                    type: "Uuid",
                    label: 'ID',
                    primaryKey: true,
                    display: false
                }
            })
    }

}